import React from "react";
import { Box, ListItemButton, Typography } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
export default function Sidebar({ menuItems }) {
  const purple = "#572575";
  const bgLight = "#FDF3FD";

  const navigate = useNavigate();
  const location = useLocation();

  const handleNavigate = (path) => {
    if (path) navigate(path);
  };

  return (
    <Box
      sx={{
        width: 140,
        bgcolor: bgLight,
        p: 1,
      }}
    >
      {menuItems.map((item, index) => {
        const isActive = location.pathname === item.path;
        return (
          <>
           
          <ListItemButton
            key={index}
            onClick={() => handleNavigate(item?.path)}
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "0 15px 15px 0",
              bgcolor: isActive ? purple : "transparent",
              color: isActive ? "white" : purple,
              transition: "all 0.2s ease",
              "&:hover": {
                bgcolor: isActive ? purple : "#EBDCF9",
                color: isActive ? "white" : purple,
              },
              mb: 2,
              py: 2,
            }}
          >
            {React.cloneElement(item.icon, {
              style: { fontSize: 24, marginBottom: 4 },
            })}
            <Typography
              sx={{
                fontSize: 12,
                fontWeight: isActive ? 600 : 500,
                textAlign: "center",
              }}
            >
              {item.text}
            </Typography>
          </ListItemButton>
          </>
        );
      })}
    </Box>
  );
}
